import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#CBCBDB",
      "fill-opacity": ".9",
      d: "M8.93 2.357a.516.516 0 0 1 .749-.054.564.564 0 0 1 .057.77q-.205.259-.422.566h3.678c.501 0 .908.406.908.907v4.588a1.7 1.7 0 0 0-.478-.118l-.18-.01h-.418V4.714h-4.17c-.114.212-.23.425-.337.661-.448.988-.65 1.85-.776 2.58h2.285l-.26.72c-.068.189-.147.467-.21.807a1.746 1.746 0 0 0 .074 2.614l-.41.409a1.8 1.8 0 0 0-.34.48c-.028-.067-.06-.135-.086-.207H3.008a.91.91 0 0 1-.908-.907V4.176c0-.297.24-.537.538-.537h5.396c.303-.494.612-.925.897-1.282M3.177 4.714v6.99h5.108q-.029-.146-.053-.298c-.01-.079-.01-.147-.018-.223-.078 0-.152.003-.232 0a9.4 9.4 0 0 1-3.024-.602.515.515 0 0 1-.28-.695.565.565 0 0 1 .717-.29c.65.24 1.544.479 2.623.513.06.002.115-.001.173 0 .033-.407.103-.765.181-1.079H6.288l.071-.6a11.9 11.9 0 0 1 .979-3.5c.035-.077.074-.141.11-.216zm2.66 1.163V7.4H4.762V5.877zm5.38-.066v1.553h-1.074V5.811z",
      style: {"fill":"color(display-p3 .7976 .7976 .8582)","fill-opacity":".9"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.222",
      d: "m10.257 13.742 2.986-2.986m0 0h-2.688m2.688 0v2.688",
      style: {"stroke":"#fff","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }